'use client'
import { Flex, Text } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { ProductContext } from '../../lib/productContext';
import InlineFormWrapper from '@/components/inlineFormWrapper';
import ProductValuePropositionForm from './productValuePropositionForm';
import { ProductPageContext } from '../lib/productPageContext';
export default function ProductValueProposition() {
  const {
    product,
    rights
  } = useContext(ProductContext);
  const {
    setEditingValueProposition,
    editingValueProposition
  } = useContext(ProductPageContext);
  return (
    <>
      { (product && 
      ( product.value_proposition || editingValueProposition )) && (
        <Flex
          p={3}
          flexDirection={"column"}
          borderTop="1px"
          borderColor="divider.grey"
        >
          <Flex
            bg="background.white"
            p={3}
            flexDirection={"column"}
            border={"1px solid"}
            borderColor={"divider.grey"}
          >
            <Text
              color="text.dark.grey"
              fontSize={"18px"}
              fontWeight={"500"}
              mb={1}
            >
              Value Proposition
            </Text>
            <InlineFormWrapper
              canEdit={rights.can_update}
              width={"100%"}
              toggle={editingValueProposition}
              onToggle={(toggle) => {
                setEditingValueProposition(toggle);
              }}
              value={
                <Text>
                  {product.value_proposition}
                </Text>
              }
            >
              {(close) => (
                <ProductValuePropositionForm
                  onSubmitted={() => {
                    close();
                    setEditingValueProposition(false);
                  }}
                  onCancel={() => {
                    close();
                    setEditingValueProposition(false);
                  }}
                />
              )}
            </InlineFormWrapper>
          </Flex>
        </Flex>
      )}
    </>
  )
}
